import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Button, Icon } from 'antd';
import { SelectionPool, SearchPool } from 'components/ui/index';
import Enums from 'utils/EnumsManager';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import Department from '../department';

const { ThemeTypes } = Enums;
const { Email } = ThemeTypes;

const TemplatePermission = ({
  teams,
  setSelectedPermissionTeam,
  setTeams,
  teamUsers,
  isPermissionVisible,
  setPermissionVisible,
  addedPermissionDepartment,
  addedPermissionUser,
  selectedFolder,
  isCurrentUser,
  handleTagClose,
  save,
  handleDoubleClickTeam,
  handleDoubleClickUser,
}) => (
  <div className="pl-lg pt-md pb-lg">
    <FormattedMessage id="page.emailTemplates.permissionTitle" />
    <SelectionPool
      theme={Email}
      teams={addedPermissionDepartment}
      users={addedPermissionUser}
      onTagClose={handleTagClose}
      closable
      withIcon
    />
    {!isPermissionVisible && selectedFolder.id && isCurrentUser() &&
      <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_ASSIGN}>
        <Button
          className="email-theme-btn mt-sm"
          size="small"
          onClick={() => setPermissionVisible(true)}
        >
          <Icon type="user" />
          <FormattedMessage id="page.emailTemplates.addNewUser" />
        </Button>
      </Permission>
    }
    {isPermissionVisible &&
      <React.Fragment>
        <Button
          className="email-theme-btn mt-sm"
          size="small"
          onClick={save}
        >
          <Icon type="save" />
          <FormattedMessage id="page.emailTemplates.save" />
        </Button>
        <Button
          className="ml-sm"
          size="small"
          onClick={() => setPermissionVisible(false)}
        >
          <Icon type="reload" />
          <FormattedMessage id="page.emailTemplates.cancel" />
        </Button>
        <Row className="pt-lg pb-lg">
          <Col className="gutter-row field-label" span={12}>
            <Department
              handleDoubleClick={handleDoubleClickTeam}
              teams={teams}
              setTeams={setTeams}
              setSelectedTeam={setSelectedPermissionTeam}
            />
          </Col>
          <Col className="gutter-row field-value" span={12}>
            <SearchPool
              theme={Email}
              title="Click Chart to Choose Department"
              users={teamUsers}
              onTagDoubleClick={handleDoubleClickUser}
            />
          </Col>
        </Row>
      </React.Fragment>
    }
  </div>
);

export default TemplatePermission;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templatePermissionComponent/TemplatePermission.js